export const getUnderlyingPoliciesForEachStatementAccountToUpdate = (
  filteredStatementAccountsToUpdate,
  allPoliciesThatWereUpdated,
  nonSAPolicies,
  billingAccounts,
  policies,
) => {
  let underlyingStatementAccountPolicies = [];
  filteredStatementAccountsToUpdate.forEach((statementAccount) => {
    let statementBillingAccount = billingAccounts.find((account) => {
      return account.fullAccount.systemId === statementAccount.systemId;
    });

    statementBillingAccount.fullAccount.underlyingBillingAccounts.forEach((account) => {
      if (account.arPolicy !== undefined) {
        let policyFind = policies.find((policy) => policy.policyRef === account.arPolicy.policyRef);
        if (policyFind) {
          let nonStatementPolicy = {
            ...policyFind,
            newPreference: statementAccount.deliveryPreference,
          };
          underlyingStatementAccountPolicies.push(nonStatementPolicy);
        }
      }
    });
  });
  allPoliciesThatWereUpdated.forEach((policy) => {
    let checkCurrentPolicy = nonSAPolicies.find(
      (underlying) => underlying.policyRef === policy.policyRef,
    );
    if (!checkCurrentPolicy) {
      underlyingStatementAccountPolicies.push(policy);
    }
  });
  return underlyingStatementAccountPolicies;
};
export const filteredNonSAPolicies = (
  allPoliciesThatWereUpdated,
  filteredStatementAccountsToUpdate,
  billingAccounts,
) => {
  return allPoliciesThatWereUpdated.filter((policy) => {
    let allUnderlyingPoliciesOfAllStatementAccounts = filteredStatementAccountsToUpdate.map(
      (statementAccount) => {
        let findBillingAccountUnderlyingPolicies = billingAccounts.find((account) => {
          return account.fullAccount.systemId === statementAccount.systemId;
        });
        return findBillingAccountUnderlyingPolicies.fullAccount.underlyingBillingAccounts.slice(1);
      },
    );
    let FindPolicy = allUnderlyingPoliciesOfAllStatementAccounts.forEach((underlyingPolicies) => {
      let found = underlyingPolicies.find(
        (underlyingPolicy) => underlyingPolicy.systemId === policy.policyRef,
      );
      return found;
    });
    return !FindPolicy;
  });
};
